// Package Imports
import { Bugfender } from '@bugfender/sdk';

// Internal Imports


const bugfenderHelper = {
  log: (message: unknown) => {
    Bugfender.log(message);
  },
  warn: (message: unknown) => {
    Bugfender.warn(message);
  },
  error: (message: unknown) => {
    Bugfender.error(message);
  }
};

export default bugfenderHelper;
